import i18n from '@speechki-frontend/core/i18n/i18n';
import { BookSettingsPage, BookUploadPage, BooksPage, ContractedBooksPage } from './views';

const routes = [
    {
        path: '/',
        name: 'home',
        component: BooksPage,
    },
    {
        path: '/books/:id',
        name: 'book-settings',
        component: BookSettingsPage,
    },
    {
        path: '/upload',
        name: 'upload',
        component: BookUploadPage,
        meta: {
            title: i18n.global.t('routes.upload'),
        },
    },
    {
        path: '/contracted',
        name: 'contracted-books',
        component: ContractedBooksPage,
        meta: {
            title: i18n.global.t('routes.contracted'),
        },
    },
];

export default routes;
